import React, { useEffect, useState, useCallback, useContext } from 'react';
import {
    Button,
    Select,
    DatePicker,
    Form,
    message,
    Dropdown,
    Menu,
    Popconfirm,
    Modal,
    Typography,
    Tag,
    Upload,
    Radio,
    Input,
    Col,
    Space
} from 'antd';
import { useQuery, useMutation } from '@apollo/react-hooks';
import { Icon } from '@ant-design/compatible';
import { GET_DASHBOARD_ITEMS } from '../../graphql/queries'
import { UPDATE_DASHBOARD_ITEM } from '../../graphql/mutations'
import time from '../../utils/time'
import chart from '../../utils/chart'
import moment from "moment";
import { Fileuploader } from '@ap-evolved/evolved-ui.ui.fileuploader'
import { v4 as uuidv4 } from 'uuid'
import { QueryBuilder } from '@cubejs-client/react'
import FilterGroup from '../QueryBuilder/FilterGroup'
import dashboardFilter from '../../utils/dashboardFilter'

async function useQueryUpdater() {
    const [updateDashboardItem] = useMutation(UPDATE_DASHBOARD_ITEM, {
        refetchQueries: [
            {
                query: GET_DASHBOARD_ITEMS,
            },
        ],
    })

    const updateQuery = useCallback(async (dashboardItem) => {
        try {
            await (updateDashboardItem)({
                variables: {
                    id: dashboardItem.id,
                    input: {
                        vizState: dashboardItem.vizState,
                        name: dashboardItem.name
                    },
                },
            });
        } catch (err) {
            console.log("Error updating query: ", err)
        }
    })

    return { updateQuery }


}

export default useQueryUpdater


